import axios from "axios";
import { APPLICATION_CONST } from "../../Config/CustomConfig";

export const processCard = (data) => {
  return new Promise((resolve, reject) => {
    const loginDetail = JSON.parse(localStorage.getItem("loginDetail"));

    const body = {
      username: loginDetail.username,
      sessionid: loginDetail.sessionid,
      failstatus: 0,
      request: data,
    };

    console.log("processcard request:", JSON.stringify(body));
    axios({
      method: "post",
      url: `${APPLICATION_CONST.url}processcard`,
      data: body,
    })
      .then((response) => {
        let resoponseData = response.data;
        console.log("response", resoponseData);
        if (resoponseData.status === 0) {
          console.log("orderid response:", JSON.stringify(resoponseData));
          resolve({
            success: true,
            statusMessage: resoponseData.statusMessage,
            data: resoponseData.data,
          });
        } else if (resoponseData.status > 0) {
          resolve({
            success: false,
            statusMessage: resoponseData.statusMessage,
            data: {},
          });
        } else {
          resolve({
            success: false,
            statusMessage: "Something went wrong",
            data: {},
          });
        }
      })
      .catch((error) => {
        resolve({
          success: false,
          statusMessage: "Error",
          data: {},
        });
      });
  });
};
